MarketReportsApp.Models.ReportBuilderComputations = Backbone.Model.extend({
	url: function() {
        return "/api/reports/post-process/computation-by-agg/" + MarketReportsApp.Variables.aggregateID  + "/" + MarketReportsApp.Variables.ComputationID;
	}
});